import src from "IMAGE";
export default { src, width: 834, height: 423, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAS0lEQVR42l3Mqw3AMAyEYYOCqi9gqaisNMoyWSE7BGeA7Oz8lowCPuA768TMZPGhQf324MKNAw8KBn7sEp8a5YuKjoxzndcoEjbPJsBMY03BRYdAAAAAAElFTkSuQmCC"};
